module.exports = __webpack_public_path__ + "static/media/back-arrow.bfbb8c22.svg";